import styled from 'styled-components';

export const ShowcaseWrapperDefaultBox = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    align-items: center;

    color: ${({theme}) => theme.colors.text};

    input[name="showcase-selector"] {
        grid-column: 1/-1;
        opacity: 0;
    }
`;